import React from "react";
import { Lock } from "lucide-react";

export const PasswordGate = ({ idPrefix, eyebrow, title, description, footnote, gate }) => {
  const { password, setPassword, login, error, submitting } = gate;
  const onSubmit = (e) => {
    e.preventDefault();
    login();
  };

  return (
    <div className="investor-gate" data-testid={`${idPrefix}-gate`}>
      <div className="glass investor-gate-card">
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 24 }}>
          <div className="step-icon">
            <Lock size={22} />
          </div>
        </div>
        <span className="eyebrow">{eyebrow}</span>
        <h1 className="h-3" style={{ margin: "8px 0 24px" }}>
          {title}
        </h1>
        <p className="body-sm" style={{ marginBottom: 24 }}>
          {description}
        </p>

        <form onSubmit={onSubmit}>
          <input
            type="password"
            className="form-input"
            placeholder="Senha de acesso"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            data-testid={`${idPrefix}-password-input`}
          />
          {error && (
            <p className="form-error" data-testid={`${idPrefix}-error`}>
              {error}
            </p>
          )}
          <button
            type="submit"
            className="btn btn-primary btn-full"
            style={{ marginTop: 16 }}
            disabled={submitting}
            data-testid={`${idPrefix}-submit`}
          >
            {submitting ? "Verificando…" : "Acessar"}
          </button>
        </form>

        <p className="mono-xs" style={{ marginTop: 24, color: "var(--color-text-muted)" }}>
          {footnote}
        </p>
      </div>
    </div>
  );
};
